import { AbstractControl } from '@angular/forms';

export function validateYear(control: AbstractControl): { [key: string]: any } | null {
  const yearInput = Number(control.value);
  const year = new Date().getFullYear();

  if (yearInput < year - 100 || yearInput > year) {
    return { invalidYear: { valid: false, value: yearInput } };
  }

  return null;
}
